import React from "react";
import { Box, Theme, Typography, useMediaQuery } from "@mui/material";
import { LinkWithRouting } from "@components/common/navigation";
import { useTranslation } from "react-i18next";
import { CopyTypography } from "@components";
import { useSharedPortfolioContext } from "@providers/SharedPortfolioProvider";
import { SecurityImage } from "@components/SecurityImage";

type Props = {
  item: {
    id?: number | string;
    wkn?: string;
    type?: string;
    isin?: string;
    hasValidIsin?: boolean;
    standardisedName?: string;
    name?: string;
    quoteProvider?: string;
  };
  circleColor?: string;
  href?: string;
  image?: string | null;
};

export const InvestmentInfo = ({ item, href, image, circleColor }: Props) => {
  const { isSharedPortfolio } = useSharedPortfolioContext();
  const { t } = useTranslation();
  const name = item.standardisedName || item.name;
  const isLessSm = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("sm")
  );

  return (
    <Box display="flex" alignItems="center" gap={2} position="relative">
      <SecurityImage
        src={image}
        width={32}
        height={32}
        alt={name}
        circleColor={circleColor}
      />
      <Box minWidth={0}>
        <Typography variant="body3" maxWidth={350} noWrap>
          {isSharedPortfolio || !href ? (
            name
          ) : (
            <LinkWithRouting
              href={href}
              onClick={(e) => e.stopPropagation()}
              onKeyDown={(e) => e.stopPropagation()}
            >
              {name}
            </LinkWithRouting>
          )}
        </Typography>

        <Box
          display="flex"
          alignItems="center"
          columnGap={2}
          rowGap={0}
          flexWrap={isLessSm ? "wrap" : "nowrap"}
        >
          {item.type && (
            <Typography color="textSecondary" variant="body3">
              {t(
                `dashboardPage.dashboard.investmentsTable.types.${item.type}`,
                {
                  count: 1,
                }
              )}
            </Typography>
          )}
          {item.wkn && !isLessSm && <CopyTypography>{item.wkn}</CopyTypography>}
          {item.hasValidIsin && item.isin && (
            <CopyTypography>{item.isin}</CopyTypography>
          )}
        </Box>
      </Box>
    </Box>
  );
};
